export default __webpack_public_path__ + "static/media/bgLab.3af30e30.jpg";